import React, { useEffect, useState } from 'react'
import { Navbar, Row, Col, Container } from 'react-bootstrap'
import { useSelector, useDispatch, connect } from 'react-redux'
import CarDetailsSection from 'application/components/pages/proposal/carDetailsSection'
import CustomerSection from 'application/components/pages/proposal/customerSection'
import NovatedLeaseSection from 'application/components/pages/proposal/novatedLeaseSection'
import DeductionSection from 'application/components/pages/proposal/deductionSection'
import TakeHomeSection from 'application/components/pages/proposal/takeHomeSection'
import RfbaSection from 'application/components/pages/proposal/rfbaSection'
import { SummarySheet } from './summarySheet'
import { SummarySheetMX } from './summarySheetMX'
import { ChecklistPdfSection } from '../proposal/checklistPdfSection'
import { createPdf } from 'application/utils/utilityFunctions'
import Icon from 'application/components/icon'
import zenscroll from 'zenscroll'
import withLocation from 'application/components/withLocation'
import { useHistory, useLocation } from 'react-router-dom'
import {
  fireInteractionCustomEvent,
  IsSpecialEmployer,
  capitalizeOnlyFirstLetter,
  IsVehicleElectric,
} from 'application/helpers'
import { NonGovdisclaimer } from '../../disclaimers/nonGovdisclaimer'
import { Govmarketingdisclaimer } from '../../disclaimers/govMarketing'
import NonInsuranceDisclaimer from '../../disclaimers/nonInsuranceDisclaimer'
import InsuranceDisclaimer from '../../disclaimers/insuranceDisclaimer'
import EstimateSummarySection from '../estimate-details/estimateSummarySection'
import {
  startedPdfDownload,
  finishedPdfDownload,
} from 'application/actions/downloadPdfAction'
import { formatDate } from '../../../helpers/index'
import { PText } from 'application/components/styledComponents/text'
import { Image as MaxxiaImage } from 'Maxxia/images'
import { Image as RemServImage } from 'RemServ/images'
import { Icon as RemServIcon } from 'RemServ/icons'
import { PrimaryButton } from '@mmsg/louie'
import * as E from './pdfElements'
import globals from 'application/constants/globals'
import { TermsAndConditions } from 'application/components/termsAndConditions'
import { TermsAndConditionsRS } from 'application/components/termsAndConditionsRS'

export const PdfView = ({
  type,
  proposalEstimateId,
  annualRate,
  leaseTerm,
  kmPerAnnum,
  nlFeePerPay,
  financeAmount,
  carRepaymentPerPayExGST,
  totalLeaseRunningCostsPerPayExGST,
  compInsuranceCommissionPerAnnumIncGST,
  gapCoverCommissionPerAnnumIncGST,
  vehicleFBTValue,
  financierEstablishmentFeePerAnnum,
  rpcCommissionPerAnnumIncGST,
  brokeragePerAnnum,
  residualPCT,
  leaseResidualAmountIncGST,
  compInsuranceCommissionExGST,
  compInsuranceCommGST,
  gapCoverCommissionExGST,
  gapCoverCommGST,
  rpcCommissionExGST,
  rpcCommGST,
  financierEstablishmentFee,
  brokerage,
  extendedWarrantyCommGST,
  extendedWarrantyCommExGST,
  extendenWarrantyCommissionPerAnnumIncGST,
  leaseProtectionCommissionPerAnnumIncGST,
  leaseProtectionCommExGST,
  procurementFee,
  fbtMethod,
  dontScroll,
  onProposalAcceptanceEvent,
  isExGST,
  evRebateApplicable,
  evRebateValue,
  evRebateLink,
  monthlyRepaymentAmountIncGST,
  retailPrice,
  priveawayPrice,
  financierFeePerPay,
  nlFeePerAnnumIncGST,
  spFeePerAnnumIncGST,
  specm,
  preTaxPerPay
}) => {
  useEffect(() => {
    dontScroll ? console.log('') : window.scrollTo(0, 0)
  }, [])

  let dispatch = useDispatch()
  let history = useHistory()
  const location = useLocation()
  const proposalIndex = location.pathname.lastIndexOf('/')
  const result = location.pathname.substring(proposalIndex + 1)
  const insuranceDisclaimer =
    result === 'review' || result === 'pdfview' || result.indexOf('-') > -1

  let isRioTinto = IsSpecialEmployer('RIO')
  let isSAGov = IsSpecialEmployer('SAG', false)
  let isNSWHN = IsSpecialEmployer('NSWHN')
  let isSAGBYO = IsSpecialEmployer('SAGBYO')
  let isREMEQ = IsSpecialEmployer('REMEQ')
  let isACTGO = IsSpecialEmployer('ACTGO')
  
  let user = useSelector((state) => state.user)
  let isGov = useSelector((state) => (globals && globals.isBrandRS) ? state && state.user && state.user.isGov : false)
  const showRecommendedRetailPrice = retailPrice > priveawayPrice

  let showRFBA =
    useSelector((state) =>
      IsVehicleElectric(state.individualEstimate.estimate, true)
    ) &&
    vehicleFBTValue &&
    vehicleFBTValue < 84916 &&
    fbtMethod &&
    fbtMethod.toLowerCase() === 'exempt'

  let isPAC = useSelector(
    (state) =>
      (state.individualEstimate && 
       state.individualEstimate.estimate && 
       state.individualEstimate.estimate.rpcProvider != null &&
       state.individualEstimate.estimate.rpcProvider.toLowerCase() ===
          'pac') ||
      (state.individualEstimate && state.individualEstimate.estimate && state.individualEstimate.estimate.extendedWarrantyProvider != null &&
        state.individualEstimate.estimate.extendedWarrantyProvider.toLowerCase() ===
          'pac')
  )

  let takeHomeSectionPointNo = '5 .'
  let rfbaPointNo = '6. '

  if (isGov || isSAGov || isNSWHN || isSAGBYO || isREMEQ) {
    takeHomeSectionPointNo = '6. '
    rfbaPointNo = '7. '
  }
  
  let url = window.location.href.toLowerCase()

  let isProposal = type === 'proposal' || url.indexOf(proposalEstimateId) !== -1

   let proposalEstimate = useSelector(
    (state) => state.individualEstimate && state.individualEstimate.estimate
  )

  let proposalNumber = useSelector(
    (state) => state.opportunity && state.opportunity.proposalNumber
  )

  proposalNumber = isProposal ? proposalNumber : null

  let nlQuoteNumber = useSelector(
    (state) => 
      (isProposal ? 'Proposal_' : 'Estimate_') + 
      state.individualEstimate &&
      state.individualEstimate.estimate &&
      state.individualEstimate.estimate.nlQuoteNumber
  )

  let dateOfProposalAcceptance = useSelector(
    (state) => isProposal ? 
      (state.proposal &&
      state.proposal.proposal &&
      state.proposal.proposal.acceptedOn) : null
  )
  
  let payFrequency =
    user && user.employer && user.employer.payFrequency
      ? user.employer.payFrequency
      : ''
  
  let negativeEquityAmount = 0

  var novatedLeaseData = {
    proposalEstimate: proposalEstimate,
    negativeEquityAmount: negativeEquityAmount,
  }

  let deductionSectionTitle = `4${(isGov || isSAGBYO) ? 'A' : ''}. Your  ${
    !isProposal ? 'estimated' : ''
  } total ${payFrequency} deductions`

  
  let proposalExpiryDate = new Date()

  let isValidDate = (date) => {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
      ? true
      : false
  }

  if (proposalExpiryDate !== null && isValidDate(proposalExpiryDate)) {
    proposalExpiryDate.setDate(proposalExpiryDate.getDate() + 30)
  }

  let { hasProposalAccepted } = useSelector((state) => state.applicationRoles)

  // OnProposalAcceptanceEvent is set to True to save the PDF in D365 with accepted state. But any business exceptions, the PDf save event will not be triggered from the backend API.
  hasProposalAccepted =
    onProposalAcceptanceEvent === true
      ? onProposalAcceptanceEvent
      : hasProposalAccepted

  const [disable, setDisable] = useState(false)
  const downloadPdfClicked = () => {
    setDisable(true)
    dispatch(startedPdfDownload())
    zenscroll.toY(0, 500, () => {
      createPdf(nlQuoteNumber, 'pdf', () => {
        setDisable(false)
        dispatch(finishedPdfDownload())
      })
    })

    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'download pdf',
          label: 'download pdf',
        },
      },
    })
  }

  let userEmployer = user && user.employer ? user.employer : null
  let userPayrollId = user && user.employer && user.employer.payrollId
  let customerName = user && user.firstName.trim() + ' ' + user.lastName.trim()
  
  const afterMarketAccessories = useSelector(
    (state) => state.individualEstimate.afterMarketAccessories
  )

  const brand = useSelector((state) => state.opportunity.brand)

  const carDetailsSectionData = proposalEstimate && {
    ...proposalEstimate.vehicle,
    vehicleType: proposalEstimate.vehicleType,
    vehicleDescription: proposalEstimate.vehicleDescription,
  }

  const novatedLeaseSectionData = {
    negativeEquityAmount: negativeEquityAmount,
    downloadingPdf: disable,
    pdf: true,
    compInsurancePremium:
      proposalEstimate && proposalEstimate.compInsurancePremium,
    compInsurancePremiumFinanced:
      proposalEstimate && proposalEstimate.compInsurancePremiumFinanced,
    compInsuranceProvider:
      proposalEstimate && proposalEstimate.compInsuranceProvider,
    driveawayPrice: proposalEstimate && proposalEstimate.driveawayPrice,
    extendedWarrantyPremium:
      proposalEstimate && proposalEstimate.extendedWarrantyPremium,
    extendedWarrantyProvider:
      proposalEstimate && proposalEstimate.extendedWarrantyProvider,
    extendedWarrantyTerm:
      proposalEstimate && proposalEstimate.extendedWarrantyTerm,
    financeAmount: proposalEstimate && proposalEstimate.financeAmount,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
    gstCreditClaimable: proposalEstimate && proposalEstimate.gstCreditClaimable,
    kmPerAnnum: proposalEstimate && proposalEstimate.kmPerAnnum,
    leaseProtectionPremium:
      proposalEstimate && proposalEstimate.leaseProtectionPremium,
    leaseResidualAmountIncGST:
      proposalEstimate && proposalEstimate.leaseResidualAmountIncGST,
    leaseTerm: proposalEstimate && proposalEstimate.leaseTerm,
    leaseTermYears: proposalEstimate && proposalEstimate.leaseTermYears,
    rpcPremium: proposalEstimate && proposalEstimate.rpcPremium,
    rpcProvider: proposalEstimate && proposalEstimate.rpcProvider,
    vehicle: proposalEstimate && {
      ...proposalEstimate.vehicle,
      vehicleType: proposalEstimate && proposalEstimate.vehicleType,
    },
    productId: proposalEstimate && proposalEstimate.productId,
    priveawayPrice: proposalEstimate && proposalEstimate.priveawayPrice,
    ctp: proposalEstimate && proposalEstimate.vehicle.ctp,
    stampDutyViaDisbursement:
      proposalEstimate && proposalEstimate.vehicle.stampDutyViaDisbursement,
    registrationFee:
      proposalEstimate && proposalEstimate.vehicle.registrationFee,
    vehicleFBTValue: proposalEstimate && proposalEstimate.vehicleFBTValue,
    evRebateApplicable,
    evRebateValue,
    evRebateLink
  }

  const deductionSectionData = {
    annualRate: proposalEstimate && proposalEstimate.annualRate,
    carRepaymentPerAnnumExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerAnnumExGST,
    carRepaymentPerAnnumIncGST:
      proposalEstimate && proposalEstimate.carRepaymentPerAnnumIncGST,
    carRepaymentPerPayExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayExGST,
    carRepaymentPerPayIncGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayIncGST,
    compInsPerAnnumExGST:
      proposalEstimate && proposalEstimate.compInsPerAnnumExGST,
    compInsPerAnnumIncGST:
      proposalEstimate && proposalEstimate.compInsPerAnnumIncGST,
    compInsPerPayExGST: proposalEstimate && proposalEstimate.compInsPerPayExGST,
    compInsPerPayIncGST:
      proposalEstimate && proposalEstimate.compInsPerPayIncGST,
    compInsurancePremium:
      proposalEstimate && proposalEstimate.compInsurancePremium,
    compInsurancePremiumFinanced:
      proposalEstimate && proposalEstimate.compInsurancePremiumFinanced,
    compInsuranceProvider:
      proposalEstimate && proposalEstimate.compInsuranceProvider,
    electricityPerAnnumExGST:
      proposalEstimate && proposalEstimate.electricityPerAnnumExGST,
    electricityPerAnnumIncGST:
      proposalEstimate && proposalEstimate.electricityPerAnnumIncGST,
    electricityPerPayExGST:
      proposalEstimate && proposalEstimate.electricityPerPayExGST,
    electricityPerPayIncGST:
      proposalEstimate && proposalEstimate.electricityPerPayIncGST,
    erAdminFeePerAnnum: proposalEstimate && proposalEstimate.erAdminFeePerAnnum,
    erAdminFeePerPay: proposalEstimate && proposalEstimate.erAdminFeePerPay,
    erSharePerAnnum: proposalEstimate && proposalEstimate.erSharePerAnnum,
    erSharePerPay: proposalEstimate && proposalEstimate.erSharePerPay,
    extendedWarrantyPremium:
      proposalEstimate && proposalEstimate.extendedWarrantyPremium,
    fbtMethod: proposalEstimate && proposalEstimate.fbtMethod,
    fbtPerAnnum: proposalEstimate && proposalEstimate.fbtPerAnnum,
    fbtPerPay: proposalEstimate && proposalEstimate.fbtPerPay,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    fuelPerAnnumExGST: proposalEstimate && proposalEstimate.fuelPerAnnumExGST,
    fuelPerAnnumIncGST: proposalEstimate && proposalEstimate.fuelPerAnnumIncGST,
    fuelPerPayExGST: proposalEstimate && proposalEstimate.fuelPerPayExGST,
    fuelPerPayIncGST: proposalEstimate && proposalEstimate.fuelPerPayIncGST,
    fuelPricePerLitre: proposalEstimate && proposalEstimate.fuelPricePerLitre,
    gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
    greenfleetPerAnnum: proposalEstimate && proposalEstimate.greenfleetPerAnnum,
    greenfleetPerPay: proposalEstimate && proposalEstimate.greenfleetPerPay,
    gstOnECMPerAnnum: proposalEstimate && proposalEstimate.gstOnECMPerAnnum,
    gstOnECMPerPay: proposalEstimate && proposalEstimate.gstOnECMPerPay,
    incidentalsPerAnnumExGST:
      proposalEstimate && proposalEstimate.incidentalsPerAnnumExGST,
    incidentalsPerAnnumIncGST:
      proposalEstimate && proposalEstimate.incidentalsPerAnnumIncGST,
    incidentalsPerPayExGST:
      proposalEstimate && proposalEstimate.incidentalsPerPayExGST,
    incidentalsPerPayIncGST:
      proposalEstimate && proposalEstimate.incidentalsPerPayIncGST,
    isGov: isGov,
    lcdaPerAnnum: proposalEstimate && proposalEstimate.lcdaPerAnnum,
    lcdaPerPay: proposalEstimate && proposalEstimate.lcdaPerPay,
    leaseProtectionPremium:
      proposalEstimate && proposalEstimate.leaseProtectionPremium,
    leaseTerm: proposalEstimate && proposalEstimate.leaseTerm,
    leaseTermYears: proposalEstimate && proposalEstimate.leaseTermYears,
    maintenancePerAnnumExGST:
      proposalEstimate && proposalEstimate.maintenancePerAnnumExGST,
    maintenancePerAnnumIncGST:
      proposalEstimate && proposalEstimate.maintenancePerAnnumIncGST,
    maintenancePerPayExGST:
      proposalEstimate && proposalEstimate.maintenancePerPayExGST,
    maintenancePerPayIncGST:
      proposalEstimate && proposalEstimate.maintenancePerPayIncGST,
    nlFeePerAnnumExGST: proposalEstimate && proposalEstimate.nlFeePerAnnumExGST,
    nlFeePerAnnumIncGST:
      proposalEstimate && proposalEstimate.nlFeePerAnnumIncGST,
    nlFeePerPayExGST: proposalEstimate && proposalEstimate.nlFeePerPayExGST,
    nlFeePerPayIncGST: proposalEstimate && proposalEstimate.nlFeePerPayIncGST,
    noOfTyresBudget: proposalEstimate && proposalEstimate.noOfTyresBudget,
    outOfPocketPerPay: proposalEstimate && proposalEstimate.outOfPocketPerPay,
    payFrequency: userEmployer.payFrequency,
    regoPerAnnumExGST: proposalEstimate && proposalEstimate.regoPerAnnumExGST,
    regoPerAnnumIncGST: proposalEstimate && proposalEstimate.regoPerAnnumIncGST,
    regoPerPayExGST: proposalEstimate && proposalEstimate.regoPerPayExGST,
    regoPerPayIncGST: proposalEstimate && proposalEstimate.regoPerPayIncGST,
    roadsideAssist: proposalEstimate && proposalEstimate.roadsideAssist,
    roadsidePerAnnumExGST:
      proposalEstimate && proposalEstimate.roadsidePerAnnumExGST,
    roadsidePerAnnumIncGST:
      proposalEstimate && proposalEstimate.roadsidePerAnnumIncGST,
    roadsidePerPayExGST:
      proposalEstimate && proposalEstimate.roadsidePerPayExGST,
    roadsidePerPayIncGST:
      proposalEstimate && proposalEstimate.roadsidePerPayIncGST,
    rpcPremium: proposalEstimate && proposalEstimate.rpcPremium,
    spFeePerAnnumExGST: proposalEstimate && proposalEstimate.spFeePerAnnumExGST,
    spFeePerAnnumIncGST:
      proposalEstimate && proposalEstimate.spFeePerAnnumIncGST,
    spFeePerPayExGST: proposalEstimate && proposalEstimate.spFeePerPayExGST,
    spFeePerPayIncGST: proposalEstimate && proposalEstimate.spFeePerPayIncGST,
    taxandMedicareSavingsLifeofLease: proposalEstimate && proposalEstimate.taxandMedicareSavingsLifeofLease,
    taxShare: proposalEstimate && proposalEstimate.taxShare,
    totalChargesPerPayExGST:
      proposalEstimate && proposalEstimate.totalChargesPerPayExGST,
    totalChargesPerPayExGSTTaxShare:
      proposalEstimate && proposalEstimate.totalChargesPerPayExGSTTaxShare,
    totalChargesPerPayIncGST:
      proposalEstimate && proposalEstimate.totalChargesPerPayIncGST,
    
    totalChargesPerPayIncGSTTaxShare:
      proposalEstimate && proposalEstimate.totalChargesPerPayIncGSTTaxShare,
    totalPackagePerAnnumExGST:
      proposalEstimate && proposalEstimate.totalPackagePerAnnumExGST,
    totalPackagePerAnnumIncGST:
      proposalEstimate && proposalEstimate.totalPackagePerAnnumIncGST,
    totalPackagePerPayExGST:
      proposalEstimate && proposalEstimate.totalPackagePerPayExGST,
    totalPackagePerPayIncGST:
      proposalEstimate && proposalEstimate.totalPackagePerPayIncGST,
    totalPackagePerPayExGSTTaxShare:
      proposalEstimate && proposalEstimate.totalPackagePerPayExGSTTaxShare,
    totalPackagePerPayIncGSTTaxShare:
      proposalEstimate &&
      proposalEstimate.totalPackagePerPayExGSTTaxShare &&
      proposalEstimate.totalPackagePerPayExGSTTaxShare * 1.1,
    tyresPerAnnumExGST: proposalEstimate && proposalEstimate.tyresPerAnnumExGST,
    tyresPerAnnumIncGST:
      proposalEstimate && proposalEstimate.tyresPerAnnumIncGST,
    tyresPerPayExGST: proposalEstimate && proposalEstimate.tyresPerPayExGST,
    tyresPerPayIncGST: proposalEstimate && proposalEstimate.tyresPerPayIncGST,
    updatedOn: proposalEstimate && proposalEstimate.updatedOn,
    vehicle: proposalEstimate && proposalEstimate.vehicle,
    erShare: proposalEstimate && proposalEstimate.erShare,
    overTheCapMethod: proposalEstimate && proposalEstimate.overTheCapMethod,
  }

  const bpFC = useSelector((state) => state.opportunity.bpFuelProvider)
  const caltexFC = useSelector((state) => state.opportunity.caltexFuelProvider)
  const shellFC = useSelector((state) => state.opportunity.shellFuelProvider)

  const fuelCards = () => {
    var fc = []
    if (bpFC)
      fc.push('BP')
    if (caltexFC)
      fc.push('Ampol')
    if (shellFC)
      fc.push('Shell')
    return fc
  }

  let accessories = []
    const thirdPartyAccessories = useSelector((state) => state.individualEstimate.estimate && 
        state.individualEstimate.estimate.vehicle && 
        state.individualEstimate.estimate.vehicle.thirdPartyOption &&
        state.individualEstimate.estimate.vehicle.thirdPartyOption.thirdPartyOptionLines)
    if(thirdPartyAccessories) {accessories.push(thirdPartyAccessories.map((x) => x.description))}
    const vehicleAccessories = useSelector((state) => state.individualEstimate.estimate && 
        state.individualEstimate.estimate.vehicle && 
        state.individualEstimate.estimate.vehicle.vehicleAccessories)
    if(vehicleAccessories) {accessories.push(vehicleAccessories.map((x) => x.name))}
    const aftermarketOrderLines = afterMarketAccessories && afterMarketAccessories.aftermarketOrderLines
    aftermarketOrderLines && aftermarketOrderLines.forEach((item) => (accessories.push( item.description)))

  const summarySheetData = {
   ...novatedLeaseData.proposalEstimate,
    employeeName: customerName,
    employeeNumber: userPayrollId,
    fuelCards: fuelCards(),
    isExGST,
    payFrequency,
    accessories
  }

   return (
     proposalEstimate && (
      <>
        <div
          data-html2canvas-ignore="true"
          style={{
            background: global.config.isBrandMX ? '#000000a1' : '#CCCCCC',
            position: 'sticky',
            top: 0,
            zIndex: 3,
            display: global.config.isBrandRS && 'flex',
            justifyContent: global.config.isBrandRS && 'flex-end',
          }}
        >
          <PrimaryButton
            disabled={disable || !proposalEstimate}
            onClick={downloadPdfClicked}
            className="m-3"
            extendInMob
          >
            Download PDF
          </PrimaryButton>
        </div>
    
        <div id="pdf">
           <div
             className="container-md navbar-container mb-3 mt-3"
             style={{ display: 'flex', justifyContent: 'center' }}
           >
             {global.config.isBrandMX && (
               <MaxxiaImage
                 className="mt-3 mb-3 d-flex justify-content-center mx-auto"
                 imageName="LogoNormal"
                 alt={global.config.brand}
               height="60px"
               />
             )}
             {global.config.isBrandRS && (
               <RemServIcon
                 iconType={isGov ? 'remservLeaseLogo' : 'remservMainLogo'}
                 className="mt-3 mb-3 d-flex justify-content-center mx-auto"
                 size={3}
               />
             )}
           </div>
  
            <div className="review-proposal-page">
              <div>
                <div className="text-center">
                  <E.PdfTitle className="banner-content  text-left">
                  <div className="text-center ">
                    <h2 className="mb-2">
                      Novated Lease {isProposal ? 'proposal ' : 'estimate '}
                      details
                    </h2>
                  </div>
                  </E.PdfTitle>
                </div>
              </div>
              
              {!proposalEstimate && (
                <Container>
                  <div className="mt-5 mb-5 d-flex justify-content-center">
                    {global.config.isBrandMX && (
                      <MaxxiaImage imageName={'Loader'} alt="" />
                    )}
                    {global.config.isBrandRS && (
                      <RemServImage imageName={'Loader'} alt="" />
                    )}
                  </div>
                </Container>
              )}

              {proposalEstimate && (
                <>
                  {user && (
                    <CustomerSection
                      data={user}
                      title="1. Your details"
                      isProposal={isProposal}
                      proposalNumber={proposalNumber}
                      dateOfProposalAcceptance={dateOfProposalAcceptance}
                      pdf={true}
                    ></CustomerSection>
                  )}
                
                  <CarDetailsSection
                    vehicle={carDetailsSectionData}
                    title="2. The car details"
                    pdf={true}
                  />
                  <div className="html2pdf__page-break" />
                  <NovatedLeaseSection
                    data={novatedLeaseSectionData}
                    afterMarketAccessories={afterMarketAccessories}
                    title="3. Your novated lease"
                    pdf={true}
                    downloadingPdf={disable}
                    isProposal={true} // same view for both pdfs
                  />
                  
                  {proposalEstimate && userEmployer && (
                    <DeductionSection
                      data={deductionSectionData}
                      title={deductionSectionTitle}
                      userEmployer={userEmployer}
                      pdf={true}
                      proposalEstimateId={proposalEstimateId}
                    />
                  )}

                  {(isGov || isSAGBYO) && proposalEstimate && userEmployer && (
                    <DeductionSection
                      data={deductionSectionData}
                      userEmployer={userEmployer}
                      title={'4B. Your total annual deductions'}
                      isAnnual={true}
                      pdf={true}
                      proposalEstimateId={proposalEstimateId}
                    />
                  )}

                  {(isGov || isSAGov || isNSWHN || isSAGBYO || isREMEQ || isACTGO) && (
                    <Container className="section mt-4">
                      <EstimateSummarySection
                        title={
                          '5. ' + capitalizeOnlyFirstLetter(type) + ' Summary'
                        }
                        employerCode={ isGov ? 'QG' : isSAGov ? 'SAG' : isNSWHN ? 'NSWHN' : isSAGBYO ? 'SAGBYO' : isACTGO ? 'ACTGO' : '' }
                        annualRate={annualRate}
                        leaseTerm={leaseTerm}
                        residualPCT={residualPCT}
                        leaseResidualAmountIncGST={leaseResidualAmountIncGST}
                        kmPerAnnum={kmPerAnnum}
                        nlFeePerPay={nlFeePerPay}
                        financeAmount={financeAmount}
                        carRepaymentPerPayExGST={carRepaymentPerPayExGST}
                        totalLeaseRunningCostsPerPayExGST={
                          totalLeaseRunningCostsPerPayExGST
                        }
                        compInsuranceCommissionPerAnnumIncGST={
                          compInsuranceCommissionPerAnnumIncGST
                        }
                        gapCoverCommissionPerAnnumIncGST={
                          gapCoverCommissionPerAnnumIncGST
                        }
                        vehicleFBTValue={vehicleFBTValue}
                        financierEstablishmentFeePerAnnum={
                          financierEstablishmentFeePerAnnum
                        }
                        rpcCommissionPerAnnumIncGST={rpcCommissionPerAnnumIncGST}
                        brokeragePerAnnum={brokeragePerAnnum}
                        compInsuranceCommissionExGST={
                          compInsuranceCommissionExGST
                        }
                        compInsuranceCommGST={compInsuranceCommGST}
                        gapCoverCommissionExGST={gapCoverCommissionExGST}
                        gapCoverCommGST={gapCoverCommGST}
                        rpcCommissionExGST={rpcCommissionExGST}
                        rpcCommGST={rpcCommGST}
                        financierEstablishmentFee={financierEstablishmentFee}
                        financierFeePerPay={financierFeePerPay}
                        brokerage={brokerage}
                        extendedWarrantyCommGST={extendedWarrantyCommGST}
                        extendedWarrantyCommExGST={extendedWarrantyCommExGST}
                        extendenWarrantyCommissionPerAnnumIncGST={
                          extendenWarrantyCommissionPerAnnumIncGST
                        }
                        leaseProtectionCommissionPerAnnumIncGST={
                          leaseProtectionCommissionPerAnnumIncGST
                        }
                        leaseProtectionCommExGST={leaseProtectionCommExGST}
                        vehicleProcurementFee={procurementFee}
                        pdf
                        brand={brand}
                        monthlyRepaymentAmountIncGST={monthlyRepaymentAmountIncGST}
                        isPAC={isPAC}
                        specm={specm}
                        fbtMethod={fbtMethod}
                        payFrequency={payFrequency}
                        preTaxPerPay={preTaxPerPay}
                      />
                    </Container>
                  )}

                  <TakeHomeSection
                    data={proposalEstimate}
                    title={
                      takeHomeSectionPointNo + 'Your resulting take home pay'
                    }
                    pdf={true}
                  />
 
                {showRFBA && (
                  <RfbaSection
                    includeContainer={true}
                    title={
                      rfbaPointNo +
                      'Electric Vehicle FBT Exemption - What you need to know'
                    }
                    pdf={true}
                  />
                )}

                {(isGov || isREMEQ) && novatedLeaseData && ( 
                  <>
                    <div className="html2pdf__page-break" />
                    <SummarySheet
                      novatedLeaseData={novatedLeaseData}
                      exGst={isExGST}
                    />
                  </>
                )}
                {(IsSpecialEmployer('VICPO')) && summarySheetData && ( 
                  <>
                    <div className="html2pdf__page-break" />
                    <SummarySheetMX
                      summarySheetData={summarySheetData}
                    />
                  </>
                )}

                {/* Currently the checklist is enabled only for three employers NSW Health Networks, Rio Tinto & SAG BYO */}
                {(isRioTinto || isNSWHN || isSAGBYO) && isProposal && proposalNumber && (        
                  <ChecklistPdfSection
                    proposalAccepted={hasProposalAccepted}
                    pdf={true}
                    isNSWHN={isNSWHN}
                    isRioTinto={isRioTinto}
                    isSAGBYO={isSAGBYO}
                  />
                )} 

                {/* Only for NSWHN: Customer signature acceptance details */}
                { isNSWHN &&
                  isProposal &&
                  proposalNumber &&
                  hasProposalAccepted && ( 
                    <>
                      <Container className="section mt-4">
                        <Row>
                          <Col lg={8} md={12} style={{ width: '100%' }}>
                            <div className="mt-2 mb-2">Your Payroll Id</div>
                            <input
                              type="text"
                              value={userPayrollId}
                              disabled
                              style={{
                                width: 'inherit',
                                height: '44px',
                                padding: '0 16px',
                                pointerEvents: 'none',
                              }}
                              className="border rounded"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={8} md={12} style={{ width: '100%' }}>
                            <div className="mt-2 mb-2">Your Full Name</div>
                            <input
                              type="text"
                              value={customerName}
                              disabled
                              style={{
                                width: 'inherit',
                                height: '44px',
                                padding: '0 16px',
                                pointerEvents: 'none',
                              }}
                              className="border rounded"
                            />
                          </Col>
                          <Col lg={4} md={12}>
                            <div className="mt-2 mb-2">Date Signed</div>
                            <input
                              type="text"
                              value={formatDate(
                                onProposalAcceptanceEvent === true
                                  ? new Date()
                                  : new Date(dateOfProposalAcceptance)
                              )}
                              disabled
                              style={{
                                height: '40px',
                                padding: '0 16px',
                                borderRadius: '40px',
                                width: '150px',
                                pointerEvents: 'none',
                              }}
                              className="border"
                            />
                          </Col>
                        </Row> 
                        <PText className="mb-3 mt-2">
                          You have already confirmed that you have read and
                          agreed with the above statements at the proposal
                          stage.
                        </PText>
                        
                      </Container>
                      <br />
                    </>
                  )
                } 
                
                { /* If not NSWHN, show proposal acceptance date if it's been accepted*/
                 !isNSWHN &&
                  isProposal &&
                  proposalNumber &&
                  hasProposalAccepted && ( 
                    <>
                      <Container className="section mt-4">
                        {isACTGO && <Row>
                          <Col>
                            <span className="mt-2 mb-2 mr-2 font-weight-bold">Name:&nbsp;</span>
                            <span>{customerName}</span>
                            </Col>
                        </Row>
                        }
                        <Row>
                          <Col>
                            <span className="mt-2 mb-2 mr-2 font-weight-bold">Date of Proposal Acceptance:&nbsp;</span>
                            <span>{formatDate(onProposalAcceptanceEvent === true
                                    ? new Date()
                                    : new Date(dateOfProposalAcceptance)
                                )}
                            </span>
                          </Col>
                        </Row> 
                        <PText className="mb-3 mt-2">
                          You have already confirmed that you have read and
                          agreed with the above statements at the proposal
                          stage.
                        </PText>
                        
                      </Container>
                      <br />
                    </>
                  )
                }   
              </>
            )}
            <div className="container-md navbar-container flex-row-reverse flex-md-row justify-content-center mt-5 mb-5 text-center">
              <Navbar.Brand>
                <Icon src="Logo" />
              </Navbar.Brand>
            </div>
            <div className="html2pdf__page-break" />
            <div className="container-md">
              <Row className="mt-1">
                     <Col xs={12}>
                  {globals.isBrandMX && 
                      <TermsAndConditions
                        payFrequency={payFrequency}
                        showRecommendedRetailPrice={showRecommendedRetailPrice}
                        nlFeePerAnnumIncGST={nlFeePerAnnumIncGST}
                        financierEstablishmentFee={financierEstablishmentFee}
                        fbtMethod={fbtMethod}
                        spFeePerAnnumIncGST={spFeePerAnnumIncGST}
                        financierFeePerPay={financierFeePerPay}
                      />
                    }
                    {globals.isBrandRS &&
                      <TermsAndConditionsRS
                        displayRetailPrice={showRecommendedRetailPrice}
                        isGov={isGov}
                        fbtMethod={fbtMethod}
                        payFrequency={payFrequency}
                        financierFeePerPay={financierFeePerPay}
                      />
                    }
                    <div className="html2pdf__page-break" />
                    {globals.isBrandRS && (isGov && !isProposal ? (
                      <Govmarketingdisclaimer />
                    ) : (
                      <NonGovdisclaimer />
                    ))}
                    {globals.isBrandMX && 
                      insuranceDisclaimer ? (
                      <InsuranceDisclaimer />
                        ) : (
                      <NonInsuranceDisclaimer />
                      )}

                  </Col>
              </Row>
            </div>
          </div>  
        </div>  
      </>
     )
   )
}

function mapStateToProps(state, ownProps) {
  const proposalEstimateId =
    state.proposal && state.proposal.proposal && state.proposal.proposal.quoteId
      ? state.proposal.proposal.quoteId
      : null

  if (!state.individualEstimate.estimate) return {}
  const employerGRS = 
    state.user &&
    state.user.employer &&
    state.user.employer.employerGRS
  const isExGST = employerGRS && employerGRS.gstExclusiveDeductionsCode === 'Yes'
  const evRebateApplicable = employerGRS && employerGRS.evRebateApplicable
  const evRebateValue = employerGRS && employerGRS.evRebateValue
  const evRebateLink = employerGRS && employerGRS.evRebateLink
  const annualRate = state.individualEstimate.estimate.annualRate
  const leaseTerm = state.individualEstimate.estimate.leaseTerm
  const kmPerAnnum = state.individualEstimate.estimate.kmPerAnnum
  const nlFeePerPay = isExGST
    ? state.individualEstimate.estimate.nlFeePerPayExGST
    : state.individualEstimate.estimate.nlFeePerPayIncGST
  const financeAmount = state.individualEstimate.estimate.financeAmount
  const carRepaymentPerPayExGST =
    state.individualEstimate.estimate.carRepaymentPerPayExGST
  const totalLeaseRunningCostsPerPayExGST =
    state.individualEstimate.estimate.totalLeaseRunningCostsPerPayExGST
  const compInsuranceCommissionPerAnnumIncGST =
    state.individualEstimate.estimate.compInsuranceCommissionPerAnnumIncGST
  const gapCoverCommissionPerAnnumIncGST =
    state.individualEstimate.estimate.gapCoverCommissionPerAnnumIncGST
  const vehicleFBTValue = state.individualEstimate.estimate.vehicleFBTValue
  const financierEstablishmentFeePerAnnum =
    state.individualEstimate.estimate.financierEstablishmentFeePerAnnum
  const rpcCommissionPerAnnumIncGST =
    state.individualEstimate.estimate.rpcCommissionPerAnnumIncGST
  const brokeragePerAnnum = state.individualEstimate.estimate.brokeragePerAnnum
  const residualPCT = state.individualEstimate.estimate.residualPCT
  const leaseResidualAmountIncGST =
    state.individualEstimate.estimate.leaseResidualAmountIncGST
  const compInsuranceCommissionExGST =
    state.individualEstimate.estimate.compInsuranceCommissionExGST
  const compInsuranceCommGST =
    state.individualEstimate.estimate.compInsuranceCommGST
  const gapCoverCommissionExGST =
    state.individualEstimate.estimate.gapCoverCommissionExGST
  const gapCoverCommGST = state.individualEstimate.estimate.gapCoverCommGST
  const rpcCommissionExGST =
    state.individualEstimate.estimate.rpcCommissionExGST
  const rpcCommGST = state.individualEstimate.estimate.rpcCommGST
  const financierEstablishmentFee =
    state.individualEstimate.estimate.financierEstablishmentFee
  const brokerage = state.individualEstimate.estimate.brokerage
  const extendedWarrantyCommGST = state.individualEstimate.estimate.extendedWarrantyCommGST
  const extendedWarrantyCommExGST =
    state.individualEstimate.estimate.extendedWarrantyCommExGST
  const extendenWarrantyCommissionPerAnnumIncGST =
    state.individualEstimate.estimate.extendenWarrantyCommissionPerAnnumIncGST
  const leaseProtectionCommissionPerAnnumIncGST =
    state.individualEstimate.estimate.leaseProtectionCommissionPerAnnumIncGST
  const leaseProtectionCommExGST = state.individualEstimate.estimate.leaseProtectionCommExGST
  const procurementFee = state.individualEstimate.estimate.vehicle.procurementFee
  const fbtMethod = state.individualEstimate.estimate.fbtMethod
  const onProposalAcceptanceEvent = ownProps.OnProposalAcceptanceEvent
  const monthlyRepaymentAmountIncGST = state.individualEstimate.estimate.monthlyRepaymentAmountIncGST
  const retailPrice = state.individualEstimate.estimate.retailPrice
  const priveawayPrice = state.individualEstimate.estimate.priveawayPrice
  const financierFeePerPay = state.individualEstimate.estimate.financierFeePerPay
  const nlFeePerAnnumIncGST = state.individualEstimate.estimate.nlFeePerAnnumIncGST
  const spFeePerAnnumIncGST = state.individualEstimate.estimate.spFeePerAnnumIncGST
  const specm = state.individualEstimate.estimate.specm
  const preTaxPerPay = state.individualEstimate.estimate.preTaxPerPay

  return {
    proposalEstimateId,
    annualRate,
    leaseTerm,
    kmPerAnnum,
    nlFeePerPay,
    financeAmount,
    carRepaymentPerPayExGST,
    totalLeaseRunningCostsPerPayExGST,
    compInsuranceCommissionPerAnnumIncGST,
    gapCoverCommissionPerAnnumIncGST,
    vehicleFBTValue,
    financierEstablishmentFeePerAnnum,
    rpcCommissionPerAnnumIncGST,
    brokeragePerAnnum,
    residualPCT,
    leaseResidualAmountIncGST,
    compInsuranceCommissionExGST,
    compInsuranceCommGST,
    gapCoverCommissionExGST,
    gapCoverCommGST,
    rpcCommissionExGST,
    rpcCommGST,
    financierEstablishmentFee,
    brokerage,
    extendedWarrantyCommGST,
    extendedWarrantyCommExGST,
    extendenWarrantyCommissionPerAnnumIncGST,
    leaseProtectionCommExGST,
    leaseProtectionCommissionPerAnnumIncGST,
    procurementFee,
    fbtMethod,
    onProposalAcceptanceEvent,
    isExGST,
    evRebateApplicable,
    evRebateValue,
    evRebateLink,
    monthlyRepaymentAmountIncGST,
    retailPrice,
    priveawayPrice,
    financierFeePerPay,
    nlFeePerAnnumIncGST,
    spFeePerAnnumIncGST,
    specm,
    preTaxPerPay
  }
}
export default connect(mapStateToProps)(withLocation(PdfView))
